import { useRef, useEffect, FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Message } from '../types/Message';

import { useSocietyAiAgentPage } from '../context/SocietyAiAgentPageContext';

import NaviOrb from './NaviOrb';
import UserMessage from './UserMessage';
import AssistantMessage from './AssistantMessage';
import FloatingComposer from './FloatingComposer';

const Conversation: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSocietyAiAgentPage();

  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [data.messages, data.isThinking]);

  return (
    <div className="navi-conversation">
      <header className="navi-conversation__header">
        <div className="navi-conversation__identity">
          <NaviOrb size={32} showSparkles={false} />
          <div>
            <p className="navi-conversation__name">
              Navi
              <span className="navi-conversation__name-suffix">- Sttok AI</span>
            </p>
            <div className="navi-conversation__status">
              <span
                className={`navi-conversation__status-dot${
                  data.isThinking
                    ? ' navi-conversation__status-dot--thinking'
                    : ''
                }`}
              />
              {data.isThinking ? t('CHATBOT_Thinking') : t('CHATBOT_Online')}
            </div>
          </div>
        </div>
        <button
          type="button"
          className="navi-conversation__reset"
          onClick={actions.handleResetConversation}
        >
          {t('CHATBOT_NewChat')}
        </button>
      </header>
      <div ref={scrollRef} className="navi-conversation__messages">
        {data.messages.map((m: Message) =>
          m.role === 'user' ? (
            <UserMessage key={m.id} content={m.content} />
          ) : (
            <AssistantMessage key={m.id} content={m.content} />
          )
        )}
        {data.streamingText ? (
          <AssistantMessage content={data.streamingText} streaming />
        ) : (
          data.isThinking && <AssistantMessage thinking />
        )}
      </div>
      <footer className="navi-conversation__footer">
        <FloatingComposer placeholder="CHATBOT_ReplyTo" />
        <p className="navi-conversation__disclaimer">
          {t('CHATBOT_VerifyMessage')}
        </p>
      </footer>
    </div>
  );
};

export default Conversation;
